import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

function ConfirmDialog({ open, title, message, onCancel, onConfirm }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t("cancel")}</Button>
        <Button onClick={onConfirm} autoFocus>{t("confirm")}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
